import { render, staticRenderFns } from "./FrzProductionGroupDetail.vue?vue&type=template&id=b8af58b2"
import script from "./FrzProductionGroupDetail.vue?vue&type=script&lang=js"
export * from "./FrzProductionGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports